export const RESET = 'CLIENTTYPE_UPDATE_RESET'
export const SET_ERROR = 'CLIENTTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CLIENTTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CLIENTTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CLIENTTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CLIENTTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CLIENTTYPE_UPDATE_UPDATE_RETRIEVED'
